import * as React from "react";
import { Fragment } from "react";

type Props = {
    panels: React.ReactNode[];
};

class Content extends React.Component<Props> {
    render() {
        const panels = this.props.panels.map((panel, i) => {
            return <Fragment key={i}>{panel}</Fragment>;
        });
        return <div className="dsh_content">{panels}</div>;
    }
}

export default Content;
